import script from "./Globals.vue?vue&type=script&lang=js"
export * from "./Globals.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__